export default {
  carPrice: 'Car price',
  carCommission: 'Car commission',
  carCompanyDiscount: 'Courier discount (car)',
  carMarketplaceDiscount: 'Marketplace discount (car)',
  carExtraHourPrice: 'Extra hour price (car)',
  carExtraKilometerPrice: 'Extra kilometer price (car)',
  carExtraHourCommission: 'Extra hour commission (car)',
  carExtraKilometerCommission: 'Extra kilometer commission (car)',
  carExcessCommission: 'Excess commission (car)',
  laborerPrice: 'Laborer price',
  laborerCommission: 'Laborer commission',
  laborerCompanyDiscount: 'Courier discount (laborer)',
  laborerMarketplaceDiscount: 'Marketplace discount (laborer)',
  laborerExtraHourPrice: 'Extra hour price (laborer)',
  laborerExtraHourCommission: 'Extra hour commission (laborer)',
  price: 'Price',
  commission: 'Commission',
  companyDiscount: 'Courier discount',
  marketplaceDiscount: 'Marketplace discount',
  extraHourPrice: 'Extra hour price',
  extraHourCommission: 'Extra hour commission',
  editor: 'Editor',
  create: 'Create',
  update: 'Update',
  delete: 'Delete',
  generate: 'Generate',
  import: 'Import',
  upsert: 'Upsert',
  logicalDelete: 'Logical delete',
  enable: 'Enable',
  disable: 'Disable',
  patch: 'Patch',
  flag: 'Flag',
  revert: 'Revert',
  complex: 'Complex',
  vehicleId: 'Vehicle ID',
  tariffId: 'Tariff ID',

  // translate log user
  latitude: 'Latitude',
  longitude: 'Longitude',
  address: 'Address',
  id: 'ID',
  creationTime: 'Creation time',
  title: 'Title',
  slug: 'slug',
  sortOrder: 'Sort order',
  userId: 'User Id',
  countryId: 'Country Id',
  provinceId: 'Province Id',
  countyId: 'County Id',
  cityId: 'City Id',
  zipCode: 'Zip code',
  plate: 'Plate',
  floor: 'Floor',
  unit: 'Unit',
  phone: 'Phone',
  mobile: 'Mobile',
  primary: 'Primary',
  hashedPassword: 'Hashed password',
  firstName: 'First name',
  lastName: 'Last name',
  mobileConfirmTime: 'Mobile confirmed time',
  fullName: 'Full name',
  name: 'Name',
  twoFactorEnabled: 'Two factor enabled',
  email: 'Email',
  gender: 'Gender',
  father: 'Father',
  birthYear: 'Birth year',
  bankCard: 'Bank card',
  realmRoles: 'Realm roles',

  // vehicle
  modelFeatureId: 'Model feature Id',
  brandId: 'Brand Id',
  companyId: 'Courier Id',
  color: 'Color',
  code: 'Code',
  year: 'Year',
  plateIranNumber: 'Plate Iran Number',
  plateLeftNumber: 'Plate left number',
  plateCharacter: 'Plate character',
  plateRightNumber: 'Plate right number',
  platePlaceOfIssue: 'Plate place of issue',
  plateOwnerId: 'Plate owner id',

  //driver
  driverId: 'Driver Id',

  // security
  permissions: 'Permissions',
  cascade: 'Cascade',

  //shipment
  clientType: 'Client Type',
  range: 'Range',
  type: 'Type',
  state: 'State',
  totalAmount: 'Total amount',
  payableAmount: 'Payable amount',
  details: 'Details',
  estimatedDistance: 'Estimated distance',
  estimatedDuration: 'Estimated duration',
  taxAmount: 'Tax amount',
  tollAmount: 'toll amount',
  commissionAmount: 'Commission amount',
  companyFeeAmount: 'Courier fee amount',
  marketplaceDiscountAmount: 'Market place discount amount',
  companyDiscountAmount: 'Courier discount amount',
  estimatedPolyLine: 'Estimated polyline',
  acceptTime: 'Accepted time',
  excessAmount: 'Excess amount',
  tariffBased: 'Tariff based',
  orderTime: 'Order time',
  roundTrip: 'Round trip',
  waitMinute: 'Wait minute',
  timeSheetTemplateId: 'Timesheet template Id',
  timeSheetDate: 'Timesheet date',
  cancelTime: 'Cancel time',
  dischargeTime: 'Discharge time',
  dischargeDayPart: 'Discharge day part',
  loadId: 'Load Id',
  packageId: 'Package Id',
  document: 'Document',
  weightTon: 'Weight',
  monetaryValue: 'Monetary value',
  cancelable: 'Cancelable',
  pricingType: 'Pricing type',
  attachments: 'Attachments',
  tester: 'Tester',

  // courier
  roles: 'Roles',
  provinces: 'Provinces',
  addressCountryId: 'Address Country Id',
  addressProvinceId: 'Address province Id',
  addressCountyId: 'Address County Id',
  addressCityId: 'Address city Id',
  addressLatitude: 'Address latitude',
  addressLongitude: 'Address longitude',
  addressAddress: 'Address',
  addressZipCode: 'Address zip code',
  nationalId: 'National Id',
  economicCode: 'Economic code',
  negotiatorName: 'Negotiator Name',
  negotiatorMobile: 'Negotiator mobile',
  brand: 'Brand',
  image: 'Image',
  description: 'Description',
  holdingId: 'Holding Id',
  ownerId: 'Owner Id',
  approved: 'Approved',
  registrationNumber: 'Registration Number',
  cities: 'Cities',

  // time-sheet
  trafficPlanId: 'Traffic plan Id',
  weekDay: 'week day',
  startTime: 'Start time',
  endTime: 'End time',
  courierId: 'Courier Id',

  //geo
  autoExpand: 'Auto expanded',
  expandedMeter: 'expanded meter',
  priority: 'Priority',

  // gateway
  provider: 'Provider',
  username: 'User name',
  password: 'Password',
  sendNumber: 'send number',
  terminalId: 'Terminal Id',

  cause: 'Cause',
  stackTrace: 'Stack trace',
  methodName: 'Method name',
  className: 'Class name',
  method: 'Method',
  unHandled: 'Unhandled',

  // web-service
  service: 'Service',

  report: 'Report',
  detail: 'Detail',
  index: 'Index',
  export: 'Export',
  instantiate: 'Instantiate',
  editImage: 'Edit image',
  soilId: 'Soil ID',
  suspendId: 'Suspend ID',
  poiId: 'Poi ID',
  poiCategoryId: 'Poi category ID',

  // general
  requestParameters: 'Request parameters',
  requestHeaders: 'Request headers'
}
